<section class="detail-section d-block" [attr.id]="id">
  <div class="now-decorative-card now-decorative-card-small mb-3">
    <h2 class="h5 mt-0 mb-2">
      <i class="now-icon {{ icon }}" aria-hidden="true"></i>
      <div class="ms-2">{{ title }}</div>
    </h2>
    @if (ausklappbar) {
      <p class="anreisser mb-0" [hidden]="!collapsed" [textContent]="anreisser | truncate: 3"></p>
      <div class="d-flex justify-content-center d-print-none">
        <button
          type="button"
          class="now-btn now-btn-tertiary now-btn-icon inhalte-schalter"
          [ngClass]="collapsed ? 'now-icon-caret-down-after' : 'now-icon-caret-up-after'"
          [attr.aria-expanded]="!collapsed"
          [attr.aria-controls]="id + '_aufklappbereich'"
          [attr.aria-label]="(collapsed ? 'mehr Inhalte: ' : 'weniger Inhalte: ') + title"
          (click)="umschalten()"
        >
          {{ collapsed ? 'mehr Inhalte' : 'weniger Inhalte' }}
        </button>
      </div>
    }
    <div
      class="voller-inhalt"
      [attr.id]="id + '_aufklappbereich'"
      [hidden]="ausklappbar && collapsed"
    >
      <ng-content></ng-content>
    </div>
  </div>
  <hr class="d-none d-print-block" />
</section>
